import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Row} from "antd";
import * as translations from "../../../constants/translations";
import * as formTypes from "../../../constants/formtypes";
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;

class LoggerNew extends Component {

    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                location: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    };

    state = {
        data: {
            "ip": ""
        },
        saving: false
    };

    formFieldTypes = {
        "ip": formTypes.TEXT,
    };

    save = async () => {
        if(!this.state.saving) {
            this.setState({saving: true});

            const request = await fetch(`${benchmarkApi}loggers` ,{
                method: 'POST',
                headers: {
                    'Content-type' : 'application/json'
                },
                body: JSON.stringify({...this.state.data, ...{location: this.props.match.params.location}})
            });
            const response = await request.json();
            console.log('save', response);

            this.setState({saving: false, data: 'reloading'});
            window.location = "/locaties/"+this.props.match.params.location;
        }
    }

    renderInput = (key) => {
        return (
            <input type="text" value={this.state.data[key]} onChange={(event) => {
                const data = {...this.state.data};
                data[key] = event.target.value;
                this.setState({data: data})
            }} />
        )
    }

    renderCol = (key, val) => {
        return <Row gutter={{xs: 0, md: 24}} className="dataview-row" key={key}>
            <Col xs={24} md={8} className="dataview-label">{translations.inverter[key] ? translations.inverter[key] : key}</Col>
            <Col xs={24} md={15} className="dataview-value">
                {
                    !this.formFieldTypes[key] || this.formFieldTypes[key] === formTypes.NONE ?
                         val : this.renderInput(key)
                }
            </Col>
        </Row>;
    }

    render() {
        const {data} = this.state;
        return (
            <div>
                <div>
                    <h1>Nieuwe Logger toevoegen</h1>
                    {Object.keys(data).filter(key => key !== "name").map((key) => this.renderCol(key, data[key]))}
                    <div>
                        <Button type={'primary'} onClick={this.save} loading={this.state.saving}>Opslaan</Button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {return {}};

export default connect(mapStateToProps)(LoggerNew);



// WEBPACK FOOTER //
// ./src/components/baseinfo/loggers/new.js